<template>
    <div class="progress__slide el-slider__button-wrapper" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" @mousedown="onButtonDown" @touchstart="onButtonDown" :class="{ 'hover': hovering, 'dragging': dragging }" :style="wrapperStyle" ref="button" tabindex="0" @focus="handleMouseEnter" @blur="handleMouseLeave">
      <el-tooltip placement="top" ref="tooltip" popper-class="slider__tooltip" :disabled="!showTooltip">
        <span slot="content">{{ formatValue }}</span>
        <div class="el-slider__button" :class="{ 'hover': hovering, 'dragging': dragging }"></div>
      </el-tooltip>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ElSliderButton',
    props: {
      value: {
        type: Number,
        default: 0
      },
      vertical: { // 暂时未写竖直情况
        type: Boolean,
        default: false
      },
      // tooltipClass: String
    },
  
    data() {
      return {
        hovering: false,
        dragging: false,
        isClick: false,
        startX: 0,
        currentX: 0,
        startY: 0,
        currentY: 0,
        startPosition: 0,
        newPosition: null,
        oldValue: this.value,
        diff: 0
      };
    },
  
    computed: {
      disabled() {
        return this.$parent.sliderDisabled;
      },
  
      showTooltip() {
        return this.$parent.showTooltip;
      },
  
      currentPosition() {
        return `${this.value}%`;
      },
  
      step() {
        return this.$parent.step;
      },
  
      enableFormat() {
        return this.$parent.formatTooltip instanceof Function;
      },
  
      formatValue() {
        return this.enableFormat && this.$parent.formatTooltip(this.value) || this.value;
      },
  
      wrapperStyle() {
        return this.vertical ? { bottom: this.currentPosition } : { left: this.currentPosition };
      }
    },
  
    watch: {
      dragging(val) {
        this.$parent.dragging = val;
      }
    },
  
    methods: {
      displayTooltip() {
        this.$refs.tooltip && (this.$refs.tooltip.showPopper = true);
      },
  
      hideTooltip() {
        this.$refs.tooltip && (this.$refs.tooltip.showPopper = false);
      },
  
      handleMouseEnter() {
        if (this.disabled) return;
        this.hovering = true;
        this.displayTooltip();
      },
  
      handleMouseLeave() {
        if (this.disabled) return;
        this.hovering = false;
        this.hideTooltip();
      },
  
      onButtonDown(event) {
        if (this.disabled) return;
        event.preventDefault();
        this.onDragStart(event);
        window.addEventListener('mousemove', this.onDragging);
        window.addEventListener('touchmove', this.onDragging);
        window.addEventListener('mouseup', this.onDragEnd);
        window.addEventListener('touchend', this.onDragEnd);
        window.addEventListener('contextmenu', this.onDragEnd);
      },
      onDragStart(event) {
        this.dragging = true;
        this.isClick = true;
        if (event.type === 'touchstart') {
          event.clientY = event.touches[0].clientY;
          event.clientX = event.touches[0].clientX;
        }
        if (this.vertical) {
          this.startY = event.clientY;
        } else {
          this.startX = event.clientX;
        }
        this.startPosition = parseFloat(this.currentPosition);
        this.newPosition = this.startPosition;
      },
  
      onDragging(event) {
        if (this.dragging) {
          this.isClick = false;
          let diff = 0
          if (event.type === 'touchmove') {
            event.clientY = event.touches[0].clientY;
            event.clientX = event.touches[0].clientX;
          }
          if (this.vertical) {
            this.currentY = event.clientY;
            diff = this.startY - this.currentY;
          } else {
            this.currentX = event.clientX;
            diff = this.currentX - this.startX;
          }
          this.newPosition = this.startPosition + diff / this.$parent.sliderSize * 100;
          this.setPosition(this.newPosition);
          this.$parent.setTooltipPosition(event)
        }
      },
  
      onDragEnd() {
        if (this.dragging) {
          /*
           * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
           * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
           */
          setTimeout(() => {
            this.dragging = false;
            this.hideTooltip();
            if (!this.isClick) {
              this.setPosition(this.newPosition);
              this.$parent.emitChange()
            }
          }, 0);
          window.removeEventListener('mousemove', this.onDragging);
          window.removeEventListener('touchmove', this.onDragging);
          window.removeEventListener('mouseup', this.onDragEnd);
          window.removeEventListener('touchend', this.onDragEnd);
          window.removeEventListener('contextmenu', this.onDragEnd);
        }
      },
  
      setPosition(newPosition) {
        if (newPosition === null || isNaN(newPosition)) return;
        if (newPosition < 0) {
          newPosition = 0;
        } else if (newPosition > 100) {
          newPosition = 100;
        }
        this.$emit('input', newPosition);
        this.$nextTick(() => {
          this.displayTooltip();
          this.$refs.tooltip && this.$refs.tooltip.updatePopper();
        });
        if (!this.dragging && this.value !== this.oldValue) {
          this.oldValue = this.value;
        }
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .progress__slide {
    &.el-slider__button-wrapper {
      height: 14px;
      width: 14px;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-slider__button {
      width: 14px;
      height: 14px;
      border: none;
      background-color: transparent;
    }
    .el-slider__button.hover,
    .el-slider__button.dragging {
      background-color: #fff;
    }
    // .el-slider__button-wrapper:hover,
    // .el-slider__button-wrapper.hover {
    //   cursor: pointer;
    // }
    .el-slider__button.dragging,
    .el-slider__button.hover,
    .el-slider__button:hover {
      transform: unset;
      // cursor: pointer;
    }
  }
  </style>
  
  <style lang="scss">
  .el-tooltip__popper.is-dark.slider__tooltip {
    background: rgba(0, 0, 0, 0.6);
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 14px;
    margin-bottom: 10px;
    .popper__arrow,
    &[x-placement^='top'] .popper__arrow::after {
      border: none;
    }
  }
  </style>
  
  